/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#takashio
 * @type {StormSurge}
 * 高潮浸水想定区域
 */
module.exports = class StormSurge {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '高潮浸水想定区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/tsunami.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#takashio'
      }
    ];
  }
}
